import { createNamespacedHelpers } from 'vuex';
import { DefineActions, DefineGetters, DefineMutations } from 'vuex-type-helper';
import { Getters, Mutations, Actions, Reports } from '@/models/Report.model';

// Inital state
const state: Reports = {
  scheduledReports: [],
};

// Gets the values of our state usually called from components
const getters: DefineGetters<Getters, Reports> = {
  scheduledReports: (state) => state.scheduledReports,
};

// TODO: Change mutation names to uppercase ( Standards )
// Sets values or changes to state. Must be called via an action.
const mutations: DefineMutations<Mutations, Reports> = {
  setScheduledReports(state, { scheduledReports }) {
    state.scheduledReports = scheduledReports;
  },
};

// Async functions that will contain the logic / service calls and commit mutations to state
const actions: DefineActions<Actions, Reports, Mutations, Getters> = {
  setScheduledReports({ commit }, payload) {
    commit('setScheduledReports', payload);
  },
};

export const {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} = createNamespacedHelpers<Reports, Getters, Mutations, Actions>('ReportsModule');

export const ReportsModule = {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};